export const DELETE_SUCCESS = 'Роль удалена';
export const DELETE_ERROR = 'Не удалось удалить роль';
